// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination-module--pagination--2HR3A"};